import React from 'react';

const Logo = ({ size = 'md', className = '', showText = true }) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10', 
    lg: 'w-12 h-12'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Smartera Logo Image */}
      <div className={`${sizeClasses[size]} relative`}>
        <img 
          src="/favicon.png" 
          alt="Smartera Logo" 
          className="w-full h-full object-contain"
        />
      </div>
      
      {/* Company Name */}
      {showText && (
        <span className={`${textSizes[size]} font-bold`}>
          <span className="text-slate-800">Smart</span><span className="text-blue-600">era</span>
        </span>
      )}
    </div>
  );
};

// Alternative component to use the larger logo.png
export const FullLogo = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16'
  };

  return (
    <div className={`${className}`}>
      <img 
        src="/logo.png" 
        alt="Smartera - Digital Solutions" 
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
    </div>
  );
};

export default Logo;
